import { onReady } from 'wly-statamic-theme-extensions';
import './bootstrap';
import './mmenu';
import './teich';
import { onLoad } from '@/scripts/onload';

onReady(() => onLoad());
